import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTimeout } from '@hooks/useTimeout';
import useFeaturesAllowed from '@hooks/useFeaturesAllowed';
import Drawer from './Drawer';
import ModalSuccess from './ModalSuccess';
import { CreateJourneyPropsInterface } from './CreateJourneyTypes';

function CreateJourney({ isMobile }: CreateJourneyPropsInterface) {
  const baseDrawerRef = useRef<HTMLDivElement>(null);
  const baseModalRef = useRef<HTMLDivElement>(null);
  const contentDrawerRef = useRef<HTMLDivElement>(null);
  const contentModalRef = useRef<HTMLDivElement>(null);
  const actionsRef = useRef<HTMLDivElement>(null);
  const [isShowDrawer, setIsShowDrawer] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
  const addTimeout = useTimeout();
  const navigate = useNavigate();
  const { isloadingFeatureAllowed } = useFeaturesAllowed();

  const isLoadingFeatureCreateProposal =
    isloadingFeatureAllowed('create-proposal');

  function onDrawerClose() {
    return new Promise<void>((resolve) => {
      baseDrawerRef.current?.classList.remove('animated');
      contentDrawerRef.current?.classList.remove('animated');
      actionsRef.current?.classList.remove('animated');

      addTimeout(() => {
        setIsShowDrawer(false);
        resolve();
      }, 200);
    });
  }

  function onModalSuccessClose() {
    return new Promise<void>((resolve) => {
      baseModalRef.current?.classList.remove('animated');
      contentModalRef.current?.classList.remove('animated');

      addTimeout(() => {
        setIsShowModalSuccess(false);
        resolve();
      }, 200);
    });
  }

  function handleDrawerClose() {
    onDrawerClose().then(() => navigate('/viagens'));
  }

  function handleModalClose() {
    onModalSuccessClose().then(() => navigate('/viagens'));
  }

  function handleOpenModalSuccess() {
    onDrawerClose().then(() => setIsShowModalSuccess(true));
  }

  function handleOpenDrawer() {
    onModalSuccessClose().then(() => setIsShowDrawer(true));
  }

  useEffect(() => {
    if (isShowDrawer && !isLoadingFeatureCreateProposal) {
      baseDrawerRef.current?.classList.add('animated');
      contentDrawerRef.current?.classList.add('animated');
      actionsRef.current?.classList.add('animated');
    }
  }, [isShowDrawer, isLoadingFeatureCreateProposal]);

  useEffect(() => {
    if (isShowModalSuccess) {
      baseModalRef.current?.classList.add('animated');
      contentModalRef.current?.classList.add('animated');
    }
  }, [isShowModalSuccess]);

  useEffect(() => {
    addTimeout(() => {
      setIsShowDrawer(true);
    }, 100);
  }, []);

  return (
    <>
      <Drawer
        isShow={isShowDrawer}
        actionsDrawerInnerRef={actionsRef}
        baseDrawerRef={baseDrawerRef}
        contentDrawerRef={contentDrawerRef}
        isMobile={isMobile}
        onClose={() => handleDrawerClose()}
        onSuccess={() => handleOpenModalSuccess()}
      />
      <ModalSuccess
        baseModalRef={baseModalRef}
        contentModalRef={contentModalRef}
        isShow={isShowModalSuccess}
        onClose={() => handleModalClose()}
        onNewJourney={() => handleOpenDrawer()}
      />
    </>
  );
}

export default CreateJourney;
